module.exports = __webpack_public_path__ + "static/media/edit.fb7d829d.svg";